export class DataStore {
  constructor(private $rootScope: ng.IRootScopeService) {}

  // NOTE! modules is a dummy object! All data is set & read directly on the
  // root scope!
  modules = {};

  create = (name) => {
    this.$rootScope[name] = {};
    return this.$rootScope[name];
  };

  get = (name) => {
    return this.$rootScope[name];
  };

  remove = (name) => {
    this.$rootScope[name] = null;
    delete this.modules[name];
  };

  set = (name, object) => {
    this.$rootScope[name] = object;
  };
}

/*
 * Service used to store namespace data per module
 */
angular.module('v6CoreModule').factory('dataStore', ($rootScope) => {
  return new DataStore($rootScope);
});
